export default __webpack_public_path__ + "static/media/error-icon.2597bba9.svg";